/**
 * SEO Analytics Utilities
 * Collection of helper functions for tracking SEO performance
 */

// Google Analytics 4 Enhanced Ecommerce Events
export const trackSEOEvents = {
  // Track when structured data is loaded
  structuredDataLoaded: (dataType: string) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: 'structured_data_loaded',
        event_category: 'SEO',
        event_label: dataType,
        custom_parameter_1: dataType
      });
    }
  },

  // Track page view with enhanced SEO data
  pageView: (page: string, language: string) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: 'page_view',
        page_title: document.title,
        page_location: window.location.href,
        language: language,
        content_group1: page,
        custom_parameter_2: language
      });
    }
  },

  // Track when users interact with rich snippets
  richSnippetClick: (snippetType: string) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: 'rich_snippet_click',
        event_category: 'SEO',
        event_label: snippetType,
        custom_parameter_3: snippetType
      });
    }
  },

  // Track Core Web Vitals
  webVitals: (metric: string, value: number) => {
    if (typeof window !== 'undefined' && window.dataLayer && (location.hostname === 'priceforms.com' || location.hostname === 'www.priceforms.com')) {
      window.dataLayer.push({
        event: metric,
        event_category: 'Web Vitals',
        value: Math.round(value),
        non_interaction: true
      });
    }
  }
};

// Schema markup validation helper
export const validateSchema = (schema: object) => {
  try {
    JSON.parse(JSON.stringify(schema));
    return true;
  } catch (error) {
    console.error('Invalid schema markup:', error);
    return false;
  }
};

// Performance monitoring for SEO (simplified for compatibility)
export const monitorSEOPerformance = () => {
  if (typeof window !== 'undefined') {
    console.info('SEO performance monitoring initialized');
    
    // Track page load performance
    window.addEventListener('load', () => {
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      if (navigation) {
        const loadTime = navigation.loadEventEnd - navigation.loadEventStart;
        trackSEOEvents.webVitals('page_load_time', loadTime);
      }
    });
  }
};

declare global {
  interface Window {
    dataLayer: any[];
  }
}